module.exports = __webpack_public_path__ + "static/media/Pic-0165.74407c4b.jpg";